module.exports = __webpack_public_path__ + "img/heart_eyes.8c05897b.png";